import {
  DEFAULT_MAPPING_CFG,
  type GestureFeatures,
  type GestureMappingConfig,
} from './types'

export function directionSignFromPalmX(
  palmX: number,
  deadzoneX: number,
): -1 | 0 | 1 {
  const d = palmX - 0.5
  if (Math.abs(d) <= deadzoneX) return 0
  return d > 0 ? 1 : -1
}

export function mapOpennessToSpeed(
  openness: number,
  fistOpenness: number,
  openOpenness: number,
  maxSpeed: number,
): number {
  if (openness <= fistOpenness) return 0
  if (openness >= openOpenness) return maxSpeed
  const t = (openness - fistOpenness) / (openOpenness - fistOpenness)
  return t * maxSpeed
}

/**
 * Mode B speed-primary mapper.
 * Does NOT write timeValue — only returns speed + intensity.
 */
export function mapGestureToControls(
  features: GestureFeatures,
  cfg: GestureMappingConfig = DEFAULT_MAPPING_CFG,
  dt: number,
  prevSpeed: number,
): { timeSpeed: number; traverseIntensity: number } {
  const safeDt = Number.isFinite(dt) ? Math.max(0, dt) : 0

  // Low confidence / no hand → decay previous speed
  if (features.confidence < 0.15) {
    const decay = Math.exp(-cfg.releaseDecay * safeDt)
    return {
      timeSpeed: prevSpeed * decay,
      traverseIntensity: 0,
    }
  }

  // Priority: bothRaised > fist > active gesture
  if (cfg.raisePause && features.bothRaised) {
    return { timeSpeed: 0, traverseIntensity: Math.abs(features.pushPull) }
  }

  if (features.openness < cfg.fistOpenness) {
    return {
      timeSpeed: 0,
      traverseIntensity: Math.min(1, Math.abs(features.pushPull)),
    }
  }

  const sign = directionSignFromPalmX(features.palmX, cfg.deadzoneX)
  const mag = mapOpennessToSpeed(
    features.openness,
    cfg.fistOpenness,
    cfg.openOpenness,
    cfg.maxSpeed,
  )
  const timeSpeed = sign * mag
  const traverseIntensity = Math.min(1, Math.abs(features.pushPull))

  return { timeSpeed, traverseIntensity }
}
